import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import user from './user';
import mine from './mine';
import student from './student';
import course from './course';
import order from './order';
import study from './study';
import exchange from './exchange';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    mine,
    student,
    course,
    order,
    study,
    exchange
  },
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js